import {
    UPDATE_UI_DATA
} from './Types';
import { UiData } from './lookupsTypes';

export const updateUiData = (uiData: UiData) => ({ type: UPDATE_UI_DATA, uiData });